module.exports = __webpack_public_path__ + "static/media/dead-heart.f63a2773.svg";